module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TzAxfC/images/cover.jpg?1684245185155",
      "alt": "This image is the cover for the book Church Street, American Heritage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Church Street, American Heritage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The 1930s and 1940s saw unprecedented prosperity for the African Americans of Jackson's Church Street. From the first black millionaire in the United States to defenders of civil rights, nearly all of Jackson's black professionals lived on Church Street. It was one of the most popular places to see and be seen, whether that meant spotting Louis Armstrong strolling out of the Crystal Palace Club or Martin Luther King Jr. organizing an NAACP meeting at his field office on nearby Farish Street. Join authors and veterans of Church Street Grace Sweet and Benjamin Bradley as they explore the astounding history and legacy of Church Street.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Grace Sweet, Benjamin Bradley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Grace Sweet was born and raised on Church Street in Jackson, Mississippi. She is a graduate of Smith Robertson Junior High School, Lanier High School and Tougaloo College. Benjamin Bradley grew up on Church Street and lives in Jackson, Mississippi.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0